module.exports = __webpack_public_path__ + "img/shutterstock_724467730.ae0fe412.jpg";